import React, { Component } from 'react'

export class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [
                { id: 4, value: 'Mastered' },
                { id: 3, value: 'With Guidance' },
                { id: 2, value: 'Emerging' },
                { id: 1, value: 'Not Observed' },
            ],
            selected: '',
        }
    }

    componentDidMount() {
        this.setState({
            selected: this.props.selected
        })
    }

    chooseOption = id => () => {
        const { question } = this.props;
        const data = {
            question_id: question.id,
            answer: id
        };

        this.setState({ selected: id });
        this.props.update(data);
    };

    render() {
        const { question, color } = this.props;
        const { options, selected } = this.state;

        const activeState = {
            backgroundImage: 'url(../../imgs/white-check.png)',
            backgroundPosition: '95% 90%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'auto',
            backgroundColor: color,
            color: 'white',
            boxShadow: 'inset 0 0 15px white'
        }
        return (
            <div className="questionBar">
                <p style={{ color }} className="question">{question.question}</p>
                <div className="buttonList">
                    {options.map(option => (
                        <button key={option.id}
                            style={selected === option.id ? activeState : {}}
                            className={`ageListBtn questionButton ${selected === option.id ? 'ageListBtn__active' : ''}`}
                            onClick={this.chooseOption(option.id)}>
                            {option.value}
                        </button>
                    ))}
                </div>
            </div>
        )
    }
}

export default Question
